// extracted by mini-css-extract-plugin
export default {"small":"SelectionPanel_small__SLrns","title":"SelectionPanel_title__gmQSy","selector":"SelectionPanel_selector__wGvwB","hidden":"SelectionPanel_hidden__KTQhZ"};